import { useState } from "react"
import { useLogin } from "../hooks/useLogin"

import '../styling/form.css'
import { strings } from "../strings"

const Login = () => {
    const [userID, setUserID] = useState('')
    const [password, setPassword] = useState('')

    const {login, isLoading, error} = useLogin()
    let w = window.innerWidth
    let h = window.innerHeight

    const handleSubmit = async (e) => {
        e.preventDefault()

        await login(userID.toLowerCase(), password)
    }

    return (
        <form className="login" onSubmit={handleSubmit} style={{ width: w > h ? '30vw' : '85vw' }}>

            <label>{strings.login.userID}</label>
            <input
                type="userID"
                onChange={(e) => setUserID(e.target.value)}
                value={userID}
            />

            <label>{strings.login.password}</label>
            <input
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
            />

            <button disabled={isLoading}>{strings.login.title}</button>
            {error && <div className="error">{error}</div>}
            
        </form>
    )
}

export default Login
